import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop } from '@material-ui/core';
import { Progress } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../make-css';

const useCss = makeCss((props) => ({
  backdrop: {
    zIndex: props.zIndex,
  },
}));

const LoadingOverlay = ({
  isInvisible,
  isOpen,
  isProgressDisabled,
  zIndex,
}) => {
  const css = useCss({ zIndex });
  return (
    <Backdrop
      aria-label={isOpen ? 'loading' : ''}
      css={css.backdrop}
      invisible={isInvisible}
      open={isOpen}
      role="status"
    >
      {!isProgressDisabled && (
        <Progress variant="indeterminate" type="circular" />
      )}
    </Backdrop>
  );
};

LoadingOverlay.propTypes = {
  isInvisible: PropTypes.bool,
  isOpen: PropTypes.bool,
  isProgressDisabled: PropTypes.bool,
  zIndex: PropTypes.number,
};

export default LoadingOverlay;
